import React, { useState, useEffect } from 'react';
import MasterTable from "../common/MasterTable";
import TopUPReqModal from '../topuprequest/TopUPReqModal';
import { axiosPostApi } from '../../helpers/interceptorServices';
import { apiList } from '../../helpers/apiList';
import CustomAlert from '../../helpers/CustomAlert';
import Loader from '../Loader/Loader';
import { toast } from 'react-toastify';
import Swal from "sweetalert2";

const TopUpReq = () => {
  const loggedInUserName = sessionStorage.getItem('username');
  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [topUpReqData, setTopUpReqData] = useState([]);
  const [custData, setCustData] = useState("")
  const [modalAction, setModalAction] = useState('');
  const [loading, setLoading] = useState(true);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageSize, setPageSize] = useState(10)
  const [currentPage, setCurrentPage] = useState(1);
  const [utrNo, setutrNo] = useState("")
  const [customerName, setCustomerName] = useState("")
  const [customerCode, setCustomerCode] = useState("")
  const [smsBalance, setsmsBalance] = useState("")

  useEffect(() => {
    fetchCust()
    // fetchTopUpReqData(1)
  }, []);

  const fetchCust = () => {
    const requestBody = {
      username: loggedInUserName,
      status: "1",
    };

    axiosPostApi(apiList.FETCH_CUSTOMER_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.data) {
          const customerCode = response?.data?.data[0]?.customerCode;
          if (customerCode) {
            fetchTopUpReqData(1);
          }
          setCustData(response?.data?.data[0])
        }
      })
      .catch((error) => {
        console.error("Error fetching retailer data:", error);
      });
  };

  const fetchTopUpReqData = async (currentPage) => {
    try {
      const requestBody = {
        username: loggedInUserName,
        // customerCode: customerCode,
        status: "",
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_TOPUP_REQ}?&pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );
      if (response?.data?.status === true && response?.data?.respCode === "00") {
        setPageDetails(response?.data?.pageDetails);
        const transactions = response?.data?.data;
        const modifiedData = modifyStructure(transactions);
        setTopUpReqData(modifiedData);
        if (modifiedData?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
      } else {
        setNoData(true);
        setTopUpReqData([]);
        // if (response?.data?.data !== null || response?.data?.respCode === "02") {
        //   CustomAlert({
        //     title: "No Data",
        //     text: response?.data?.message || "No data available for the specified criteria.",
        //     icon: 'info',
        //     confirmButtonText: 'Okay'
        //   });
        // }
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry"
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    return response?.map((item, index) => ({
      ...item,
      transactionDate: item.transactionDate?.split(" ")?.[0],
      id: index + 1,
    }));
  };

  const topUpReqHeaders = [
    "Attachment",
    "Status",
    "A/c Department Remark",
    "Trans Date",
    "UTR no",
    "Payment mode",
    "Total Amount",
    "Amount Tranferred",
    "Pending Amount",
    "Trans Bank Name",
    "Request Date",
    "Vendor Name",
    "checked By",
    "checked Date",
    "Auth date",
    "Auth by"
  ];

  const topUpReqHeaderToKeyMap = {
    "Attachment": "attachment",
    "Status": "authStatus",
    "A/c Department Remark":"remark",
    "Trans Date":"txnDate",
    "UTR no":"utrNo",
    "Payment mode":"payMode",
    "Total Amount":"totalAmount",
    "Amount Tranferred":"paidAmount",
    "Pending Amount":"pendingAmount",
    "Trans Bank Name":"bankName",
    "Request Date":"reqDate",
    "Vendor Name":"vendorName",
    "checked By":"checkedBy",
    "checked Date":"checkedDate",
    "Auth date":"authDate",
    "Auth by":"authBy"
  }

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
    setModalAction('');
  };

  const handlerTopUpReqSMS = (id, actionType = "view") => {
    setModalAction(actionType);
  
    if (actionType === "add") {
      setEditData({});
      setShowModal(true);
    } else if (actionType === "delete") {
      setutrNo(id.utrNo);
      setCustomerName(id.customerName);
      setCustomerCode(id.customerCode);
      setsmsBalance(id.oldSmsBalance);
      setShowModal(true);
    } else if (actionType === "auth") {
      setutrNo(id.utrNo);
      setCustomerName(id.customerName);
      setCustomerCode(id.customerCode);
      setsmsBalance(id.oldSmsBalance);
      setShowModal(true);
    } else if (actionType === "view") {
      let data = topUpReqData.find((item) => item.id === id?.id);
      if(data){
      setEditData(data);
      setShowModal(true);
      }
    }
  };

  const handleFinalAuthorization = (authData) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to accept this top-up request?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#00b6ce",
      cancelButtonColor: "#e74c3c",
      confirmButtonText: "Yes, accept it!",
      cancelButtonText: "No, cancel!",
      customClass: {
        confirmButton: "swal-confirm-button",
        cancelButton: "swal-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const requestBody = {
          ...authData,
          username: loggedInUserName,
          status: "1",
        };
  
        axiosPostApi(apiList.AUTH_BLOCK_TOPUP_REQ, requestBody)
          .then((response) => {
            if (response?.status === 200 && response?.data?.respCode === "00") {
              toast.success("Top-up request accepted successfully!");
              fetchTopUpReqData(1);
            } else {
              CustomAlert({
                title: "Failed to Accept Request",
                text: response.data?.message || "Invalid credentials. Please try again!",
                icon: "error",
                confirmButtonText: "Retry",
              });
            }
          })
          .catch((error) => {
            console.error("Error Authorizing request", error);
            toast.error("Failed to Authorize request.");
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        toast.info("Authorization request canceled.");
      }
    });
  };
  

const pageSizeCount = pageDetails === null  ? 0 : pageDetails.pageSize;
const totalRecord = pageDetails === null  ? 0 : pageDetails.totalRecords;

  return (
    <div>
       {loading ?
      <Loader/>: 
        <>
      <MasterTable
        headers={topUpReqHeaders}
        data={topUpReqData}
        handleAction={handlerTopUpReqSMS}
        filterFields={['customerName']}
        entityType="Top-up SMS Request"
        headerToKeyMap={topUpReqHeaderToKeyMap}
        loading={loading}
        handleAuth={handleFinalAuthorization}
        pageDetails={pageDetails}
        noData={noData}
        currentPage={currentPage}
        pageSize={pageSizeCount}
        totalRecord={totalRecord}
        fetchNextData={fetchTopUpReqData}
        setCurrentPage={setCurrentPage}
      />
      <TopUPReqModal
        show={showModal}
        handleClose={handleCloseModal}
        editData={editData}
        action={modalAction}
        data={topUpReqData}
        fetchData={fetchTopUpReqData}
        customerData={custData}
        utrNo={utrNo}
        customerName={customerName}
        customerCode={customerCode}
        smsBalance={smsBalance}
      />
       </>}
    </div>
  )
}

export default TopUpReq